import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import axiosinterce from '../function/axiosInterceptor';
function Mainmenu() {
    const [menus, setMenu] = useState([])
    const getApiData = async () => {
        try {
            const response = await axiosinterce.get('/admin/menu-list')
            if (response.status === 1) { setMenu(response.data) }
        } catch (err) {

        }

    }
    useEffect(() => { getApiData(); }, []);

    const Delete_menu = (m) => {
        axiosinterce.post('/admin/del-menu', { sno: m.currentTarget.id }).then((res) => {
            if (res.status === 'success') {
                toast('Menu Succussfully deleted.', 0);
                getApiData();
            } else {
                toast(res.data['status'], 1);
            }
        }).catch((error) => {
            toast('something went wrong', 1);
        });
    }
    const AddMainmenu = (sub) => {
        sub.preventDefault();
        if (sub.currentTarget.name.value != '') {
            axiosinterce.post('/admin/menu', {
                name: sub.currentTarget.name.value,
                url: sub.currentTarget.url.value,
                categorie: "0",
                ActiveStatus: sub.currentTarget.actstatus.value,
                sort: 1
            }).then((res) => {
                if (res.status == 'success') {
                    toast('Menu Succussfully added.', 0);
                    getApiData();
                } else {
                    toast(res.status, 1);
                }
            }).catch((error) => {
                toast('something went wrong', 1);
            });
        } else {
            if (sub.currentTarget.name.value == '') { toast('Please enter manu name...!!', 1); return; }
            if (sub.currentTarget.url.value == '') { toast('Please enter manu url...!!', 1); return; }
        }
    }
    return (<>
        <Card>
            <Card.Header>Main Menu</Card.Header>
        </Card>
        <div className='row mt-4'>
            <div className='col-lg-5 col-xl-5 grid-margin grid-margin-xl-0 stretch-card'>
                <Card>
                    <Card.Header>Add Menu</Card.Header>
                    <Card.Body>
                        <Form onSubmit={AddMainmenu}>
                            <fieldset>
                                <Form.Group className="mb-3">
                                    <Form.Label htmlFor="name">Menu Name</Form.Label>
                                    <Form.Control id="name" placeholder="Name" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label htmlFor="url">Url</Form.Label>
                                    <Form.Control id="url" placeholder="Url" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label htmlFor="actstatus">Status</Form.Label>
                                    <Form.Select id="actstatus">
                                        <option value={0}>Inactive</option>
                                        <option value={1}>Active</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        id="disabledFieldsetCheck"
                                        label="Remember Me"
                                    />
                                </Form.Group>
                                <Button type="submit">Add Menu</Button>
                            </fieldset>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
            <div className='col-lg-5 col-xl-7 grid-margin grid-margin-xl-0 stretch-card'>
                <Card>
                    <Card.Header>Menu List</Card.Header>
                    <Card.Body>
                        <Table bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Menu</th>
                                    <th>Children</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    menus.map((menu) => {
                                        if (menu.category == 0) {
                                            return (<>
                                                <tr>
                                                    <td>{menu.sort}</td>
                                                    <td>{menu.name}</td>
                                                    <td>{
                                                        menus.map((submenu) => {
                                                            if (menu.sno == submenu.category) {
                                                                return (<>
                                                                    <div className="Container" dangerouslySetInnerHTML={{ __html: submenu.name + ",<br/>" }}></div>

                                                                </>)
                                                            }
                                                        })
                                                    }</td>
                                                    <td>{menu.status === 1 ? <div className='bg-success text-white rounded-pill text-center'>Active</div> : <div className='bg-warning text-white rounded-pill text-center'>inactive</div>}</td>
                                                    <td>
                                                        <DropdownButton id="dropdown-basic-button" title="Action">
                                                            <Dropdown.Item><Link to={"/admin/mainmenu/" + menu.sno}>Edit</Link></Dropdown.Item>
                                                            <Dropdown.Item onClick={Delete_menu} id={menu.sno}>Delete</Dropdown.Item>
                                                        </DropdownButton>
                                                    </td>
                                                </tr>
                                            </>)
                                        }
                                    })
                                }
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        </div>
    </>);
}

export default Mainmenu;